/* APEX WASH — Shopify theme engine (port of apex.js: announcement, nav,
   cart drawer w/ dual AOV bars, tier filter, gallery swap, toasts) */
(function () {
  'use strict';

  var S = window.APEX_SETTINGS || {};
  var T = window.APEX_TRANSLATIONS || {};
  var routeRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function money(cents) {
    var v = (Number(cents) || 0) / 100;
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style: 'currency', currency: S.currency || 'USD', maximumFractionDigits: 2}).format(v);
  }

  /* ---------------- SVG bits (v4-exact) ---------------- */
  function peakSvg(size) {
    size = size || 27;
    var w = Math.round(size * (34 / 27));
    var gid = 'ap_' + Math.random().toString(36).slice(2, 8);
    return '<svg class="peak" width="' + w + '" height="' + size + '" viewBox="0 0 50 40" fill="none" aria-hidden="true">' +
      '<path d="M25 4 L46 36 H33 L25 21 L17 36 H4 Z" fill="url(#' + gid + ')"/>' +
      '<defs><linearGradient id="' + gid + '" x1="4" y1="36" x2="46" y2="4" gradientUnits="userSpaceOnUse">' +
      '<stop stop-color="#1FA2FF"/><stop offset="1" stop-color="#12D8FA"/></linearGradient></defs></svg>';
  }

  /* ---------------- toast (v4-exact: peak icon + tappable action) ---------------- */
  var toastTimer = null;
  function toast(msg, action) {
    var host = $('#apex-toast');
    if (!host) {
      host = document.createElement('div');
      host.id = 'apex-toast';
      document.body.appendChild(host);
    }
    host.className = 'apex-toast';
    host.innerHTML = '<span class="apex-toast-peak">' + peakSvg(18) + '</span><span>' + esc(msg) + '</span>' +
      (action ? '<span class="apex-toast-cta" style="color:var(--cyan);font-weight:700;margin-left:12px;white-space:nowrap">View loadout →</span>' : '');
    host.style.cursor = action ? 'pointer' : '';
    host.onclick = action ? function () { host.classList.remove('show'); openCart(); } : null;
    host.classList.add('show');
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { host.classList.remove('show'); }, 3200);
  }

  function pulseCart() {
    $all('.cart-btn').forEach(function (el) {
      el.style.transition = 'transform .18s cubic-bezier(.2,.8,.3,1.4)';
      el.style.transform = 'scale(1.18)';
      setTimeout(function () { el.style.transform = ''; }, 200);
    });
  }

  /* ---------------- cart (Shopify AJAX) ---------------- */
  var cartState = null;
  var cartUpdating = false;
  var cartReturnFocus = null;

  function readResponse(response) {
    return response.json().then(function (data) {
      if (!response.ok) throw new Error(data.description || data.message || T.cart_error);
      return data;
    });
  }

  function acceptCart(cart) {
    if (!cart || !Array.isArray(cart.items)) throw new Error(T.cart_error);
    cartState = cart;
    return cart;
  }

  function thumbnailUrl(image) {
    var url = new URL(image, window.location.origin);
    url.searchParams.set('width', '120');
    return url.href;
  }

  function requestedQuantity(button) {
    var input = document.querySelector('[data-apex-quantity][data-product-id="' + button.getAttribute('data-apex-product-id') + '"]');
    return Math.max(1, Math.floor(Number(input && input.value) || 1));
  }

  function fetchCart() {
    return fetch(routeRoot + 'cart.js', { credentials: 'same-origin' })
      .then(readResponse).then(acceptCart);
  }

  function updateCount() {
    var el = $('.cart-count');
    if (!el || !cartState) return;
    el.textContent = cartState.item_count;
    el.classList.toggle('is-empty', cartState.item_count === 0);
  }

  /* v4-exact AOV progress bar */
  function progressBar(label, current, target, doneMsg, goal) {
    var pct = Math.max(0, Math.min(100, (current / target) * 100));
    var remaining = target - current;
    var unlocked = remaining <= 0;
    var status = unlocked ? doneMsg : money(remaining) + ' away';
    var icon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 7h11v8H2z"/><path d="M13 10h4l3 3v2h-7z"/><circle cx="7" cy="17.2" r="1.5"/><circle cx="17" cy="17.2" r="1.5"/></svg>';
    return '' +
      '<div class="bar" data-goal="' + esc(goal || 'ship') + '">' +
        '<div class="bar-top">' +
          '<span class="bar-label">' + icon + esc(label) + '</span>' +
          '<span class="bar-status' + (unlocked ? ' is-unlocked' : '') + '">' + esc(status) + '</span>' +
        '</div>' +
        '<div class="bar-track"><span class="bar-fill" style="width:' + pct.toFixed(1) + '%"></span></div>' +
      '</div>';
  }

  function tidyCat(c) {
    if (!c) return '';
    if (/FULL ARSENAL/i.test(c)) return 'The Arsenal';
    return c.replace(/\s*·.*$/, '');
  }
  function monogram(name) {
    return String(name || '').replace(/^Apex\s+/i, '').slice(0, 2).toUpperCase();
  }
  var META = window.APEX_META || {};

  function renderCart() {
    var body = $('#apex-cart-body');
    if (!body || !cartState) return;
    var subtotal = cartState.total_price;

    var bars = '' +
      '<div class="bars">' +
        progressBar(T.free_us_shipping, 1, 1, T.no_minimum, 'ship') +
      '</div>';

    if (!cartState.items.length) {
      body.innerHTML = '' +
        bars +
        '<div class="cart-empty">' +
          '<div class="cart-empty-peak">' + peakSvg(40) + '</div>' +
          '<p class="cart-empty-title">Your loadout is empty</p>' +
          '<p class="cart-empty-sub">Build your kit — every finish hits the same peak clean.</p>' +
          '<a class="btn btn-primary" href="' + esc(routeRoot + 'collections/the-full-arsenal') + '">Browse the Arsenal</a>' +
        '</div>';
      return;
    }

    var savings = Number(cartState.total_discount) || 0;
    var lines = cartState.items.map(function (it) {
      var m = META[it.handle] || {};
      var media = it.image
        ? '<div class="line-media line-media-img" style="--tc:' + esc(m.c || '#12D8FA') + '"><img src="' + esc(thumbnailUrl(it.image)) + '" alt="' + esc(it.product_title) + '" loading="lazy"></div>'
        : '<div class="line-media line-media-mono" style="--ac:#12D8FA"><span>' + esc(monogram(it.product_title)) + '</span></div>';
      var sub = m.a ? ((m.t || '') + (m.f ? ' · ' + m.f : '')) : tidyCat(it.product_type);
      return '' +
        '<div class="line" data-key="' + esc(it.key) + '">' +
          media +
          '<div class="line-info">' +
            '<a class="line-name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
            '<div class="line-sub">' + esc(sub) + '</div>' +
            '<div class="line-qty">' +
              '<button class="qbtn" type="button" data-act="dec" aria-label="Decrease quantity">−</button>' +
              '<span class="qnum">' + it.quantity + '</span>' +
              '<button class="qbtn" type="button" data-act="inc" aria-label="Increase quantity">+</button>' +
              '<button class="line-remove" type="button" data-act="rm">Remove</button>' +
            '</div>' +
          '</div>' +
          '<div class="line-price">' + money(it.final_line_price != null ? it.final_line_price : it.price * it.quantity) + '</div>' +
        '</div>';
    }).join('');

    body.innerHTML = '' +
      bars +
      '<div class="drawer-lines">' + lines + '</div>' +
      '<div class="drawer-foot">' +
        (savings > 0 ? '<div class="drawer-subtotal drawer-save" style="color:var(--cyan);font-weight:700"><span>You save</span><span>−' + money(savings) + '</span></div>' : '') +
        '<div class="drawer-subtotal"><span>Subtotal</span><span>' + money(subtotal) + '</span></div>' +
        '<p class="drawer-note">' + esc(T.shipping_note) + '</p>' +
        '<a class="btn btn-primary drawer-checkout" href="' + esc(routeRoot + 'checkout') + '">Secure Checkout</a>' +
        '<button class="btn btn-ghost drawer-continue" type="button">Keep Building</button>' +
      '</div>';
  }

  function openCart() {
    var host = $('#apex-cart');
    if (!host) return;
    fetchCart().then(function () { renderCart(); updateCount(); }).catch(function (error) {
      var body = $('#apex-cart-body');
      if (body && !cartState) body.innerHTML = '<div class="cart-empty"><p>' + esc(T.cart_error) + '</p><a class="btn btn-primary" href="' + esc(routeRoot + 'cart') + '">' + esc(T.view_cart) + '</a></div>';
      toast(error.message || T.cart_error);
    });
    var d = $('.drawer', host);
    var ov = $('.drawer-overlay', host);
    if (d) {
      if (!d.classList.contains('open')) cartReturnFocus = document.activeElement;
      d.inert = false;
      d.classList.add('open'); d.setAttribute('aria-hidden', 'false');
      var close = $('[data-close-cart]', d);
      if (close) close.focus();
    }
    if (ov) ov.classList.add('open');
    document.body.classList.add('apex-noscroll');
  }
  function closeCart() {
    var host = $('#apex-cart');
    if (!host) return;
    var d = $('.drawer', host);
    var ov = $('.drawer-overlay', host);
    if (d) { d.classList.remove('open'); d.setAttribute('aria-hidden', 'true'); d.inert = true; }
    if (ov) ov.classList.remove('open');
    document.body.classList.remove('apex-noscroll');
    if (cartReturnFocus && cartReturnFocus.isConnected) cartReturnFocus.focus();
  }

  function addToCart(variantId, qty) {
    return fetch(routeRoot + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: qty || 1 })
    }).then(readResponse);
  }

  function changeQty(key, qty) {
    if (cartUpdating) return Promise.resolve();
    cartUpdating = true;
    var controls = $all('#apex-cart [data-act]');
    controls.forEach(function (button) { button.disabled = true; });
    return fetch(routeRoot + 'cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(readResponse).then(acceptCart).then(function () {
      renderCart(); updateCount();
    }).catch(function (error) {
      toast(error.message || T.cart_error);
    }).finally(function () {
      cartUpdating = false;
      controls.forEach(function (button) { button.disabled = false; });
    });
  }

  /* delegated clicks */
  document.addEventListener('click', function (e) {
    var add = e.target.closest('[data-add]');
    if (add) {
      e.preventDefault();
      if (add.disabled) return;
      var vid = add.getAttribute('data-add');
      if (!vid) return;
      add.disabled = true;
      addToCart(vid, requestedQuantity(add)).then(function () {
        add.disabled = false;
        pulseCart();
        openCart();
      }).catch(function (err) {
        add.disabled = false;
        toast(err.message || 'Could not add to loadout');
      });
      return;
    }
    var bn = e.target.closest('[data-buy-now]');
    if (bn) {
      e.preventDefault();
      if (bn.disabled) return;
      bn.disabled = true;
      addToCart(bn.getAttribute('data-buy-now'), requestedQuantity(bn)).then(function () {
        window.location.href = routeRoot + 'checkout';
      }).catch(function (err) {
        bn.disabled = false;
        toast(err.message || 'Could not start checkout');
      });
      return;
    }
    if (e.target.closest('[data-open-cart]')) { openCart(); return; }
    if (e.target.closest('[data-close-cart]') || e.target.closest('.drawer-continue')) { closeCart(); return; }
    var act = e.target.closest('[data-act]');
    if (act && cartState) {
      var row = act.closest('.line');
      var key = row && row.getAttribute('data-key');
      if (!key) return;
      var item = cartState.items.filter(function (i) { return i.key === key; })[0];
      if (!item) return;
      var a = act.getAttribute('data-act');
      if (a === 'inc') changeQty(key, item.quantity + 1);
      else if (a === 'dec') changeQty(key, item.quantity - 1);
      else if (a === 'rm') changeQty(key, 0);
    }
  });

  document.addEventListener('keydown', function (event) {
    var drawer = $('#apex-cart .drawer.open');
    if (!drawer) return;
    if (event.key === 'Escape') { event.preventDefault(); closeCart(); return; }
    if (event.key !== 'Tab') return;
    var controls = $all('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),[tabindex="0"]', drawer).filter(function (el) { return el.getClientRects().length; });
    var first = controls[0], last = controls[controls.length - 1];
    if (!first) { event.preventDefault(); return; }
    if (event.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && (document.activeElement === last || !drawer.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
  });

  /* boot: sync cart badge */
  fetchCart().then(updateCount).catch(function () {});
})();

